var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add a Technician Payment"},on:{"on-hide":_vm.resetFormData}},[_c('technician-payments-form',{key:_vm.formKey,on:{"on-submit":_vm.createTechnicianPayment,"on-save":_vm.redirectToTechnicianPayment,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }